import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "@/components/site/Reveal";

const FounderStory = () => (
    <section id="founder" data-testid="founder-section" className="py-14 sm:py-20">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <FadeUp>
                <div className="card-surface grid items-center gap-10 overflow-hidden p-8 sm:p-12 lg:grid-cols-2">
                    <div className="group relative mx-auto w-full max-w-md">
                        <div className="absolute -inset-4 rounded-[2.4rem] bg-gradient-to-br from-[#3fcbf3]/20 via-transparent to-[#f0356f]/20 blur-xl" />
                        <div className="relative overflow-hidden rounded-[1.8rem] border border-white/10">
                            <img
                                src="/brand/transform-1.webp"
                                alt="SHREDxpro founder — before and after transformation"
                                loading="lazy"
                                className="aspect-square w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                            />
                            <span className="absolute left-3 top-3 rounded-full border border-white/20 bg-black/55 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-white/80 backdrop-blur-sm">
                                Before
                            </span>
                            <span className="absolute right-3 top-3 rounded-full border border-[#3fcbf3]/40 bg-[#070c15]/70 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-[#3fcbf3] backdrop-blur-sm">
                                After
                            </span>
                            <span className="absolute bottom-3 left-3 rounded-full bg-black/55 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-white/80 backdrop-blur-sm">
                                The founder's own transformation
                            </span>
                        </div>
                    </div>

                    <div>
                        <p className="eyebrow">Meet The Founder</p>
                        <h2 className="font-display mt-4 text-4xl leading-[1.08] text-white sm:text-5xl">
                            Built by someone who lived it.
                        </h2>
                        <p className="mt-6 text-base leading-relaxed text-[#9fb0c7]">
                            SHREDxpro wasn't designed in a boardroom. It came from years of
                            inconsistent training, generic plans and guesswork — and the decision
                            to fix it properly.
                        </p>
                        <p className="mt-4 text-base leading-relaxed text-[#9fb0c7]">
                            The founder's own transformation became the proof of concept:
                            personalized training, honest nutrition and a system that adapts as you
                            do. Every feature in SHREDxpro exists because it solved something he
                            actually struggled with.
                        </p>
                        <p className="mt-6 border-l-2 border-[#f0356f] pl-4 text-sm font-semibold italic leading-relaxed text-white">
                            "I built the coach I wish I had on day one."
                        </p>
                        <Link to="/register" data-testid="founder-cta" className="btn-primary mt-8">
                            Start Your Own Transformation <ArrowRight className="h-4 w-4" />
                        </Link>
                    </div>
                </div>
            </FadeUp>
        </div>
    </section>
);

export default FounderStory;
